exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "body{overflow-x:hidden}body.show-mobile-menu,body.hide-overflow,body.show-sectors{overflow-x:hidden !important;overflow:hidden !important}", ""]);

